import listActions from 'src/modules/nutritionInformation/list/nutritionInformationListActions';
import NutritionInformationService from 'src/modules/nutritionInformation/nutritionInformationService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import Message from 'src/view/shared/message';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'NUTRITIONINFORMATION_DESTROY';

const nutritionInformationDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: nutritionInformationDestroyActions.DESTROY_STARTED,
      });

      await NutritionInformationService.destroyAll([id]);

      dispatch({
        type: nutritionInformationDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(i18n('entities.nutritionInformation.destroy.success'));

      dispatch(listActions.doFetchCurrentFilter());

      navigateTo('/library/nutrition-information');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: nutritionInformationDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: nutritionInformationDestroyActions.DESTROY_ALL_STARTED,
      });

      await NutritionInformationService.destroyAll(ids);

      dispatch({
        type: nutritionInformationDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(i18n('entities.nutritionInformation.destroyAll.success'));

      navigateTo('/library/nutrition-information');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: nutritionInformationDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default nutritionInformationDestroyActions;
